export default __webpack_public_path__ + "static/media/1280.6c08b862.png";